/**
 * Client/Community layout renders the same route twice (desktop + mobile shells).
 * The first `form` / field in document order is often the hidden desktop tree.
 * Scope DOM queries to the shell that is actually visible.
 */
export function getActiveDashboardLayoutScope(): Document | Element {
  const mobile = document.querySelector('[data-layout-mobile-shell]');
  if (mobile && window.getComputedStyle(mobile as HTMLElement).display !== 'none') {
    return mobile as Element;
  }

  const desktop = document.querySelector('[data-layout-desktop-shell]');
  if (desktop && window.getComputedStyle(desktop as HTMLElement).display !== 'none') {
    return desktop as Element;
  }

  return document;
}

/** First matching visible field (name or data-field-anchor) inside the active layout shell. */
export function queryFirstVisibleFieldInActiveLayout(fieldKey: string): HTMLElement | null {
  const scope = getActiveDashboardLayoutScope();
  const combo = `[name="${CSS.escape(fieldKey)}"], [data-field-anchor="${CSS.escape(fieldKey)}"]`;
  const list = scope.querySelectorAll<HTMLElement>(combo);

  for (let i = 0; i < list.length; i++) {
    const el = list[i];
    const st = window.getComputedStyle(el);
    if (st.display === 'none') continue;
    const r = el.getBoundingClientRect();
    if (r.width <= 0 && r.height <= 0) continue;
    return el;
  }

  return list[0] ?? null;
}
